
<template>
  <div v-if="['super_admin', 'sys_admin'].includes(profile.roles[0].name)">
    <v-data-table
      :headers="headers"
      :items="users"
      class="elevation-0"
      :loading="loading"
      :search="search"
      hide-default-footer
    >

      <template v-slot:top>
        <v-row class="px-3 pt-2 mb-2" justify='end'>
          <v-btn
            color="primary"
            rounded
            small
            class="white--text elevation-0 text-capitalize"
            @click="addUser()"
          >
            <v-icon left small>mdi-plus</v-icon>
            {{ $t("companies.users_config.add_new") }}
          </v-btn>
        </v-row>
      </template>
      <template v-slot:item.status="{item}">
        <!-- <v-switch inset dense v-model="item.status" false-value="inactive" true-value="active"
          @change="updateCompanyStatus(item)"
        ></v-switch> -->
      </template>

      <!-- <template v-slot:item.pay_status="{item}">
        {{ $t(`companies.pay_statuses.${item.pay_status}`) }}
      </template> -->

      <template v-slot:item.json_attributes.occupation="{item}">
        <span>{{ item.json_attributes && item.json_attributes.occupation }} </span>
      </template>

      <template v-slot:item.role_names="{item}">
        <span>{{ $t(`user_roles.${item.role_names[0]}`) }} </span>
      </template>

      <template v-slot:item.actions="{item}">
        <v-btn icon small color="primary" v-if="item.role_names[0] != 'super_admin'" @click="showUser(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <dialog-create-user-employee v-if="dialog_create" @close="handleCloseCreate"></dialog-create-user-employee>
    <dialog-edit-user-employee v-if="dialog_edit" :user="selected_user" @close="handleCloseEdit"></dialog-edit-user-employee>


    <div v-if="false" v-for="user in users" :key="user.id" class="my-2">
      <v-card>
        <v-card-text class="pa-3">
          <!-- {{ user }} -->
          <v-row class="pa-3" align='center'>
            <v-col cols="12" sm="10" md="9">
              <div>
                <v-row class="pa-3">
                  <div class="mr-4">
                    <b>{{$t('name')}}: </b>
                    <span>{{ user.name }} </span>
                  </div>
        
                  <div>
                    <b>E-mail: </b>
                    <span>{{ user.name }} </span>
                  </div>
                </v-row>
      
                <v-row class="pa-3">
                  <div class="mr-4">
                    <b>{{$t('employees.occupation_form_label')}}: </b>
                    <span>{{ user.json_attributes && user.json_attributes.occupation }} </span>
                  </div>
        
                  <div>
                    <b>{{$t('employees.permission_form_label')}}: </b>
                    <span>{{ $t(`user_roles.${user.role_names[0]}`) }} </span>
                  </div>
                </v-row>
              </div>
            </v-col>

            <v-col>
              <v-btn icon small color="primary" @click="showUser(user)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogCreateUserEmployee from './DialogCreateUserEmployee.vue'
import DialogEditUserEmployee from './DialogEditUserEmployee.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'CompanyUsersList',
  //mixins: [ validations ],
  components: {
    DialogCreateUserEmployee,
    DialogEditUserEmployee,
    //ComponentName: () => import(''),
  },
  props: {
    users: {
      type: Array,
    },
  },
  data() {
    return {
      headers: [
        // {text: this.$t('status'), value: 'status',},
        {text: 'E-mail', value: 'email',},
        {text: this.$t('employees.occupation_form_label'), value: 'json_attributes.occupation',},
        {text: this.$t('employees.permission_form_label'), value: 'role_names',},
        // {text: this.$t('companies.plan_form_label'), value: 'plan',},
        // {text: this.$t('companies.renewal_date_form_label'), value: 'renewal_date',},
        {text: this.$t('action'), value: 'actions', sortable: false},
      ],

      dialog_create: false,
      dialog_edit: false,
      selected_user: null,
    }
  },
  methods: {
    handleCloseCreate(){
      this.selected_user = null
      this.dialog_create = false 
      this.dialog_edit = false
    },
    handleCloseEdit(){
      this.selected_user = null
      this.dialog_create = false 
      this.dialog_edit = false
    },
    showUser(item) {
      this.selected_user = {...item}
      this.dialog_edit = true
    },
    addUser(){
      this.dialog_create = true
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      profile: (state) => state.User.oneUser,
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>